// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__i7H85","list":"PatternAutocomplete_list__2IuLc"};